const DEFAULT_DEVICE_PIXEL_RATIO = 2;

export function getDevicePixelRatio(): number {
  if (typeof window === "object") {
    return window.devicePixelRatio;
  }

  return DEFAULT_DEVICE_PIXEL_RATIO;
}
